
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/stores/shopping-cart/extra-dates.store.js